import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EventTicketComplete } from '../../../../../../data-services/models/event-tickets/event-ticket-complete.model';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { adminActions } from '../../../../../../data-services/stores/actions/admin.actions';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToggleSwitchModule } from 'primeng/toggleswitch';


@Component({
  selector: 'app-admin-ticket-edit',
  imports: [FontAwesomeModule,FormsModule,ReactiveFormsModule,InputNumberModule, ToggleSwitchModule],
  templateUrl: '../ui/edit.component.html',
  styleUrl: '../ui/edit.component.css'
})
export class AdminEditTicketComponent implements OnInit{
  private readonly _store = inject(Store);
  @Input({ required: true}) eventTicket!: EventTicketComplete;
  @Input() isOdd:boolean = false;
  @Input() isEven:boolean = false;
  @Output() closeClicked = new EventEmitter();

  ticketForm: FormGroup = new FormGroup({
    id: new FormControl<number>(0),
    description: new FormControl<string>(''),
    cost: new FormControl<number>(0),
    availableFrom: new FormControl<Date>(new Date()),
    availableTo: new FormControl<Date>(new Date(new Date().setDate(new Date().getDate() + 1))),
    restrictions: new FormControl<string | undefined>(undefined),
    available: new FormControl<boolean>(false)
  })

  ngOnInit(): void {
    this.ticketForm.patchValue({
      id: this.eventTicket.ticketID,
      description: this.eventTicket.description,
      cost: this.eventTicket.cost,
      restrictions: this.eventTicket.restrictions,
      availableFrom: this.eventTicket.availableFrom,
      availableTo: this.eventTicket.availableTo,
      available: this.eventTicket.available,
      caterer: this.eventTicket.caterer
    })
  }

  saveChanges() {
    this._store.dispatch(adminActions.updateEventTicket({
      eventTicket: {
        ...this.eventTicket,
        restrictions: this.ticketForm.value['restrictions'],
        description: this.ticketForm.value['description'],
        availableFrom: new Date(Date.parse(this.ticketForm.value['availableFrom'])),
        availableTo: new Date(Date.parse(this.ticketForm.value['availableTo'])),
        cost: Number.parseFloat(this.ticketForm.value['cost']),
        caterer: this.ticketForm.value['caterer']
      }
    }))
    this.closeClicked.emit();
  }
}
